import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import PasswordModel from '../registration/models/passwordModel'

export default mixins(routeMixin).extend({
    methods: {
        init(model: PasswordModel) {
            model.email = this.query('email')
            model.code = this.query('code')
        },
        validate(model: PasswordModel) {
            this.$http
                .api('account/resetpassword', true)
                .post(model)
                .then(() => {
                    this.$swal.toast.success()
                    this.navigateToLogin()
                })
                .catch(x => this.$swal.toast.errorApi(x))
        }
    }
})
